<template>
    <div class="bio-detail">
        <z-link
            v-if="data.nav['back-link']"
            class="bio-detail__back-link"
            size="m"
            iconPosition="left"
            icon="arrow"
            :href="data.nav['back-link']"
            >{{ text.linkText }}</z-link
        >
        <div class="bio-detail__head">
            <div
                class="bio-detail__image"
                v-if="data.detailPicture && data.detailPicture.link"
                :style="`background-image: url(${data.detailPicture.link})`"
            >
            </div>
            <div v-else class="bio-detail__image" style="background-image: url(/images/biographies/imageholder.svg)"></div>
            <div class="bio-detail__person">
                <div class="bio-detail__name" v-html="data.name"></div>
                <div class="bio-detail__post" v-html="data.position.value"></div>
                <div class="bio-detail__committee" v-if="data.committee">
                    <div
                        v-for="(committee, i) in data.committee"
                        :key="committee.code"
                        class="bio-detail__committee-el"
                    >
                        <div
                            class="bio-detail__committee-letter"
                            :style="{
                                'background-color': colorsEnum[i]
                            }"
                        >{{getFirstLetterCommittee(committee.name)}}</div>
                        <span v-html="committee.name"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bio-detail__content">
            <div class="bio-detail__detail" v-if="data.previewText">
                <div class="bio-detail__position-description" v-html="data.previewText"></div>
            </div>
            <div class="bio-detail__position" v-if="data.destination.value">
                <div class="bio-detail__position-title" v-html="text.destination"></div>
                <vue-raw class="html-content bio-detail__position-description" v-html="data.destination.value"></vue-raw>
            </div>
            <div class="bio-detail__experience" v-if="data.experience.value">
                <div class="bio-detail__experience-title" v-html="text.experience"></div>
                <vue-raw class="html-content bio-detail__experience-description" v-html="data.experience.value"></vue-raw>
            </div>
            <div class="bio-detail__education" v-if="data.education.value">
                <div class="bio-detail__education-title" v-html="text.education"></div>
                <vue-raw class="html-content bio-detail__education-description" v-html="data.education.value"></vue-raw>
            </div>
        </div>
        <page-changer
            v-if="data.nav.prev || data.nav.next"
            :data="{ next: { name: data.nav.next ? data.nav.next.name : '', url: data.nav.next ?  data.nav.next.url : ''}, prev: { name: data.nav.prev ? data.nav.prev.name : '', url: data.nav.prev ? data.nav.prev.url : ''} }"
            class="bio-detail__footer u-top-margin--l"
        />
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'bio-detail',
    data () {
        return {
            text: {
                destination: localize({
                    ru: 'Назначение',
                    en: 'Appointment'
                }),
                education: localize({
                    ru: 'Образование',
                    en: 'Education'
                }),
                experience: localize({
                    ru: 'Опыт работы',
                    en: 'Experience'
                }),
                linkText: localize({
                    ru: 'Вернуться к списку',
                    en: 'Back to list'
                })
            },
            colorsEnum: [
                '#075078',
                '#0642A3',
                '#16076E'
            ],
            data: this.$root.app.components['bio-detail']
        }
    },
    methods: {
        getFirstLetterCommittee (text) {
            let letter = ''

            if (this.$root.lang === 'ru') {
                letter = text.substr(11, 1)
            } else {
                letter = text[0]
            }

            return letter
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
